import { render, staticRenderFns } from "./TypeSelectionStep.vue?vue&type=template&id=548d6c22"
import script from "./TypeSelectionStep.vue?vue&type=script&lang=js"
export * from "./TypeSelectionStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports